const GoogleMaps = {
  install(Vue: any, { apiKey }: any) {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    document.head.appendChild(script);
  },
};

export default GoogleMaps;
